import React, { FC } from 'react';
import clsx from 'clsx';

import { Sorting } from '../components/Sorting';
import { DivLeft, DivRight, DivTableSubheader } from '../styles';
import { Tags } from '../components/Tags';
import { FilterBox } from '../components/FilterBox';
import {
  TCurrentFilter,
  TCurrentTextBox,
  TCurrentTextBoxIsLoadingState,
  TFilter,
  TGroupedFilter,
  TSort
} from '../../../commonTypes/filters';
import FnAlert from '../../../components/elements/FnAlert';
import { FnAlertTypes } from '../../../components/elements/FnAlert/constants';

type TProps = {
  isOpen: boolean;
  filters: TFilter[];
  groupedFilters: TGroupedFilter[];
  currentFilterItems: TCurrentFilter[];
  currentTextBoxItems: TCurrentTextBox[];
  sortItems: TSort[];
  currentSortItem: TSort;
  isLoadingStates: TCurrentTextBoxIsLoadingState[];
  onSwitchFilter: () => void;
  onClearAllFilters: () => void;
  onSetFilter: (data: TCurrentFilter) => void;
  onClearFilter: (data: string) => void;
  onClearCurrentTextBoxValues: (data: string[]) => void;
  onFetchDataTextBoxFilterAction: (internalName: string, searchValue: string) => void;
  onFetchCancel: (internalName: string) => void;
  onSortChange: (data: TSort) => void;
  errorMassage?: string;
};

export const ModalFilter: FC<TProps> = ({
  isOpen,
  filters,
  groupedFilters,
  currentFilterItems,
  currentTextBoxItems,
  sortItems,
  currentSortItem,
  isLoadingStates,
  onSwitchFilter,
  onClearAllFilters,
  onSetFilter,
  onClearFilter,
  onClearCurrentTextBoxValues,
  onFetchDataTextBoxFilterAction,
  onFetchCancel,
  onSortChange,
  errorMassage = ''
}) => (
  <>
    <DivTableSubheader>
      <DivLeft>
        <Sorting onSortChange={onSortChange} sortItems={sortItems} currentSortItem={currentSortItem} />
        <Tags
          onSwitchFilter={onSwitchFilter}
          onClearAllFilters={onClearAllFilters}
          onSetFilter={onSetFilter}
          onClearFilter={onClearFilter}
          currentFilterItems={currentFilterItems}
          filters={filters}
        />
      </DivLeft>
      {errorMassage && (
        <DivRight>
          <FnAlert type={FnAlertTypes.Error}>{errorMassage}</FnAlert>
        </DivRight>
      )}
    </DivTableSubheader>
    <FilterBox
      className={clsx({ ['filter-open']: isOpen }, 'filter-modal')}
      onSwitchFilter={onSwitchFilter}
      onClearAllFilters={onClearAllFilters}
      onSetFilter={onSetFilter}
      onClearFilter={onClearFilter}
      onClearCurrentTextBoxValues={onClearCurrentTextBoxValues}
      onFetchDataTextBoxFilterAction={onFetchDataTextBoxFilterAction}
      onFetchCancel={onFetchCancel}
      filters={groupedFilters}
      currentFilterItems={currentFilterItems}
      currentTextBoxItems={currentTextBoxItems}
      isLoadingStates={isLoadingStates}
    />
  </>
);
